import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { connect } from "react-redux";
import { History } from "history";
import { FormattedMessage } from "react-intl";

import { URLS } from "constants/urlConstants";
import ContactForm from "./partials/ContactForm";
import Support from "./partials/Support";
import UserManuals from "./partials/UserManuals";
import { ICustomer, IUser } from "models/.";

import "./style.scss";

interface IProps {
  currentCustomer: ICustomer;
  user: IUser;
  history: History;
  location: Location;
}

interface IState {
  currentTab: number;
}

const getTabId = pathname => {
  switch (pathname) {
    case URLS.CONTACT_URL:
      return 2;
    case URLS.USER_MANUALS_URL:
      return 1;
    default:
      return 0;
  }
};

class ServiceAndSupport extends React.Component<IProps, IState> {
  private constructor(props) {
    super(props);

    this.state = {
      currentTab: getTabId(props.location.pathname)
    };
  }

  public componentWillReceiveProps(nextProps) {
    const {
      location: { pathname }
    } = nextProps;
    if (pathname !== this.props.location.pathname) {
      this.setState({
        currentTab: getTabId(pathname)
      });
    }
  }

  public render() {
    const { currentCustomer, user, history } = this.props;

    return (
      <div id="service-support-page">
        <FormattedMessage id="SERVICE_SUPPORT" tagName="h1" />
        <div className="container">
          <Tabs
            selectedIndex={this.state.currentTab}
            onSelect={currentTab => this.setState({ currentTab })}
          >
            <TabList>
              <Tab onClick={() => history.push(URLS.SERVICE_AND_SUPPORT_URL)}>
                <FormattedMessage id="FAQ" />
              </Tab>
              <Tab onClick={() => history.push(URLS.USER_MANUALS_URL)}>
                <FormattedMessage id="USER_MANUALS" />
              </Tab>
              <Tab onClick={() => history.push(URLS.CONTACT_URL)}>
                <FormattedMessage id="CONTACT_CNB" />
              </Tab>
            </TabList>
            <hr />
            <TabPanel>
              <Support />
            </TabPanel>
            <TabPanel>
              <UserManuals />
            </TabPanel>
            <TabPanel>
              <ContactForm
                currentCustomer={currentCustomer}
                user={user}
                onBackClick={() => history.back()}
              />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  currentCustomer: state.app.currentCustomer,
  user: state.app.user
}))(ServiceAndSupport);
